import React from 'react';
import { useHistory } from 'react-router-dom';


// Material UI
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Add from '@material-ui/icons/Add';

// Core components
import CatalogsTablePage from '../CatalogsTablePage';
import MicrocredencialBody from './MicroCredentialsBody';

// @local
import { useStyles } from '../../../../assets/styles/jss/pages/microcredentials/useStyles';


function NewRequestButton({ setRequest, setOpenModal, setModalData }) {
  const classes = useStyles();

  const onClickOption = () => {
    const newRequest = {
      workflow: [],
      form: { id: null, name: '', templatePoc: '', credentialId: '' },
    };
    setRequest(newRequest);
    setModalData(newRequest);
    setOpenModal(true);
  };

  return (
    <Button
      onClick={onClickOption}
      startIcon={<Add />}
      className={classes.buttonCrear}
      variant="contained"
    >
      Crear Microcredencial
    </Button>
  );
}


const MicroCredentials = () => {
  const classes = useStyles();
  const history = useHistory();
  const [request, setRequest] = React.useState({});
  const [state] = React.useState({ canReadWrite: true });
  const [openModal, setOpenModal] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const [refreshTable, setRefreshTable] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    console.log('isLoading cambió a:', isLoading);
  }, [isLoading]);

  return (
    <Box>
      <Box mb={3}>
        <Typography variant="h1" component="h1" gutterBottom>
          Microcredenciales
        </Typography>
        <Typography
          variant="h6"
          component="h2"
          color="textSecondary"
          className={classes.catalogoSubtitulo}
        >
          Todas las microcredenciales
        </Typography>
      </Box>

      {/* Contenedor principal */}
      <Box
        style={{
          width: '100%',
          padding: '20px',
          backgroundColor: '#1c1f24',
          borderRadius: '10px',
        }}
      >
        {/* Header con botón de crear */}
        <Box display="flex" justifyContent="flex-end" mb={2}>
          {state.canReadWrite && (
            <NewRequestButton
              setRequest={setRequest}
              setOpenModal={setOpenModal}
              setModalData={setModalData}
            />
          )}
        </Box>

        <Divider
          style={{
            width: '100%',
            marginBottom: '50px',
            borderBottom: '1px solid #A0A9BA',
          }}
        />

        {/* Tabla */}
        <CatalogsTablePage
          key={refreshTable}
          canReadWrite={state.canReadWrite}
          catalogType="microcredential"
          setRequest={setRequest}
          history={history}
          refreshTrigger={refreshTable}
          onEditItem={(formData) => {
            setModalData({ form: formData });
            setOpenModal(true);
          }}
        />
      </Box>

      {/* Modal */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
        className={classes.modalDialog}
      >
        <DialogTitle className={classes.modalTitle}>
          <Typography
            variant="h6"
            style={{ color: '#9F6FFB', fontWeight: 600 }}
          >
            {modalData?.form?.id ? 'Editar Microcredencial' : 'Crear Microcredencial'}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <MicrocredencialBody
            readOnly={false}
            onClose={() => setOpenModal(false)}
            onSuccess={() => {
              setOpenModal(false);
              setRefreshTable((prev) => prev + 1);
            }}
            onLoadingChange={setIsLoading}
            formData={modalData?.form}
          />
        </DialogContent>
      </Dialog>

      {/* Spinner */}
      <Backdrop className={classes.backdrop} open={isLoading}>
        <Box className={classes.spinner}>
          <CircularProgress color="inherit" size={60} />
          <Typography className={classes.spinnerText}>
            Guardando microcredencial...
          </Typography>
        </Box>
      </Backdrop>
    </Box>
  );
};

export default MicroCredentials;
